import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth';

export const authGuard = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated$.pipe(
    take(1),
    switchMap(isAuthenticated => {
      if (isAuthenticated) {
        return of(true); // If service reports authenticated, trust it.
      }
      // If not, check the session on the server (for page refresh scenarios)
      return authService.checkSession();
    }),
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      }
      // If all checks fail, redirect to login.
      return router.createUrlTree(['/admin/login']);
    })
  );
};
